const Payments = {
  paymentPath: (id: string) => `/api/payments/${id}`,
  paymentsPath: (type: string) => `ExternalSale/myReservations?type=${type}`,
};

export default Payments;
